// PDP polish v2: nutrition modal + pill, slide cleanup, anti-floating-ATC.
(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn()} else {document.addEventListener('DOMContentLoaded',fn)} }
  ready(function(){
    var car=document.querySelector('[data-id="gp-carousel-gz3p89KAQw"]');
    if(car && !document.querySelector('.pdp-nutri-pill')){
      // Desktop gallery is a static stack (pdp-polish.css §7): pill anchors to
      // the hero slide. Mobile keeps the carousel: pill floats over all slides.
      var host=car;
      if(window.matchMedia('(min-width:768px)').matches){
        var s0=car.querySelector('.gem-slider-item');
        if(s0) host=s0;
      }
      host.classList.add('pdp-nutri-host');
      var pill=document.createElement('button');
      pill.className='pdp-nutri-pill'; pill.type='button';
      pill.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="#039869" stroke-width="1.8"><path d="M12 21c-5 0-8-3.5-8-8 0-5.5 4.5-9 11-9 1.7 0 3 .2 4 .5-.3 9.5-3.5 16.5-7 16.5z"/><path d="M6 19c2-5 5-9 10-12"/></svg> Nutritional Information';
      host.appendChild(pill);

      var wrap=document.createElement('div');
      wrap.innerHTML=`<div class="nutri-overlay" id="nutriModal" hidden>
    <div class="nutri-modal" role="dialog" aria-modal="true" aria-label="Nutritional Information">
      <button class="nutri-close" aria-label="Close">×</button>
      <h2 class="nutri-title">Nutritional Information</h2>

      <div class="facts-panel">
        <p class="facts-title">Supplement Facts</p>
        <p class="facts-serving">Serving Size: 2 Capsules<br />Servings Per Container: 30</p>
        <div class="facts-bar"></div>
        <div class="facts-head"><span>Amount Per Serving</span><span>%DV</span></div>
        <div class="facts-row"><span class="fr-name">Dandelion Extract (leaf)</span><span class="fr-amt">200 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name"><em>Echinacea purpurea</em> Extract (whole plant)</span><span class="fr-amt">200 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name">Burdock Powder (root)</span><span class="fr-amt">150 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name">Cleavers 10:1 Extract (<em>Galium aparine</em>) (whole herb)</span><span class="fr-amt">150 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name">Bromelain Powder (<em>Ananas comosus</em>)<br /><span class="fr-sub">(stem) (std. to 2400 Gdu/g)</span></span><span class="fr-amt">100 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name">Red Root Powder</span><span class="fr-amt">100 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name">Rutin (<em>Sophora japonica</em>) (whole flower bud)</span><span class="fr-amt">100 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name">Ginger Extract (root)</span><span class="fr-amt">50 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name">Lemon Peel Powder (peel)</span><span class="fr-amt">50 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-row"><span class="fr-name">BioPerine<sup>®</sup> Black Pepper Extract (fruit)</span><span class="fr-amt">5 mg</span><span class="fr-dv">**</span></div>
        <div class="facts-bar"></div>
        <p class="facts-note">** Daily Value (DV) not established.</p>
        <p class="facts-other"><strong>Other Ingredients:</strong> Cellulose (vegetable capsule), Brown Rice Flour, Olive Oil.</p>
      </div>

      <button class="btn-cta nutri-cta">Try Lymphatic Drainage Risk-Free</button>

      <div class="nutri-points">
        <span>Made &amp; produced in the USA</span>
        <span>100% Natural Ingredients</span>
        <span>60-Day Money-Back Guarantee</span>
        <span>Free Shipping</span>
      </div>
    </div>
  </div>`;
      var overlay=wrap.firstElementChild;
      document.body.appendChild(overlay);
      var cta=overlay.querySelector('.nutri-cta');
      if(cta) cta.textContent='Try Lymphelle+ Risk-Free';

      function open(){ overlay.hidden=false; document.documentElement.style.overflow='hidden'; }
      function close(){ overlay.hidden=true; document.documentElement.style.overflow=''; }
      pill.addEventListener('click',open);
      overlay.addEventListener('click',function(e){ if(e.target===overlay) close(); });
      overlay.querySelector('.nutri-close').addEventListener('click',close);
      document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
      if(cta) cta.addEventListener('click',function(){ close();
        var atc=document.querySelector('button[name="add"]');
        if(atc) atc.scrollIntoView({block:'center',behavior:'smooth'});
      });
    }

    if(window.matchMedia('(max-width:767px)').matches){
      setTimeout(function(){
        document.querySelectorAll('.gem-slider-item').forEach(function(s){
          var img=s.querySelector('img');
          if(img && /card_2\.png/.test(img.src)) s.remove();
        });
        window.dispatchEvent(new Event('resize'));
      }, 600);
    }

    setInterval(function(){
      document.querySelectorAll('button[name="add"]').forEach(function(b){
        var el=b, d=0;
        while(el && d<8){
          var cs=getComputedStyle(el);
          if(cs.position==='fixed'){
            var r=el.getBoundingClientRect();
            if(window.innerHeight - r.bottom > 90) el.style.setProperty('display','none','important');
          }
          el=el.parentElement; d++;
        }
      });
    }, 1200);
  });
})();
